import { BasicService } from "./core/basic.service";
import { Storage } from "./core/storage";
import { Navigate } from "../assets/utils/navigate";
import store from '../store/index';

export class LoginService extends BasicService {

  static login(username, pwd) {
    return this.http.post('/admin/login',{username, pwd}).then(token => {
      Storage.set('token', token.access_token);
      return token;
    });

  }

  static async logout() {
    await this.http.post('/admin/logout');
    store.commit({ type: 'clearCachePages' });
    Storage.clear();
    Navigate.route.push('/login');
  }
}